import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { TextInput, TableRow, TableData } from '@digitools/honest-react';
import BdmBeneficiaryUtils from '../utils/BdmBeneficiaryUtils';
import BdmModalDeleteBeneficiary from '../modals/BdmModalDeleteBeneficiary';
import BdmModalEditBeneficiary from '../modals/BdmModalEditBeneficiary';
import { BDM_BENEFICIARY_TYPES, BDM_BENEFICIARY_TYPES_ES } from '../constants/BdmConstants';
import { BdmAddBeneficiaryModalDisplayTextEn as LanguageEn } from '../language/BdmAddBeneficiaryModalDisplayTextEn';
import { BdmAddBeneficiaryModalDisplayTextEs as LanguageEs } from '../language/BdmAddBeneficiaryModalDisplayTextEs';
import { ExperienceContext } from '../../../providers/ExperienceProvider';
import { Language } from '../../../types/Language';
import StatusBadge from "src/components/Cards/StatusBadge";
const benPerson = BDM_BENEFICIARY_TYPES[0].value;
const benEstate = BDM_BENEFICIARY_TYPES[1].value;
const benCharity = BDM_BENEFICIARY_TYPES[2].value;
const benTrust = BDM_BENEFICIARY_TYPES[3].value;
const StyledTextInput = styled(TextInput) `
  height: 2.5rem;
  text-align: center;
  padding-left: 0;
  padding-right: 0;
`;
const StyledDiv = styled('div') `
  align-items: center;
  justify-content: flex-start;
`;
const StyledSpan = styled('span') `
  margin-right: 1rem;
  min-width: 200px;
  display: inline-block;
`;
export const BeneficiaryRow = ({ index, beneficiary, beneficiaries, onValueChange, toggleButtonState, handleDeleteBeneficiary, updateBeneficiaries, }) => {
    const [rerenderAllocation, setRerenderAllocation] = useState(true);
    const experienceContext = useContext(ExperienceContext);
    const displayText = experienceContext.language === Language.SPANISH ? LanguageEs : LanguageEn;
    const { firstName, middleInitial, lastName, charityName, trustName, beneficiaryCategory, beneficiaryType, allocation, } = beneficiary;
    let placeholder;
    switch (beneficiaryType) {
        case benPerson:
            placeholder = beneficiary.firstName + " " + beneficiary.lastName;
            break;
        case benEstate:
            placeholder = beneficiary.firstName + " " + beneficiary.lastName;
            break;
        case benCharity:
            placeholder = charityName;
            break;
        case benTrust:
            placeholder = trustName;
            break;
    }
    const benName = placeholder;
    const getBeneficiaryTypeLabel = (benType) => {
        const labels = experienceContext.language === 'es' ? BDM_BENEFICIARY_TYPES_ES : BDM_BENEFICIARY_TYPES;
        let label = benType;
        labels.map(ben => {
            if (ben.value === benType) {
                label = ben.label;
            }
        });
        return label;
    };
    return (<TableRow>
      <TableData style={{ verticalAlign: 'middle' }}>
        <StyledDiv className='d-flex'>
          <StyledSpan>
            {beneficiaryType === benPerson || beneficiaryType === benEstate
            ? <span data-private={true}>{`${firstName} ${middleInitial || ''} ${lastName}`}</span>
            : null}
            {beneficiaryType === benCharity ? <span data-private={true}>{charityName}</span> : null}
            {beneficiaryType === benTrust ? <span data-private={true}>{trustName}</span> : null}
          </StyledSpan>
          <BdmModalEditBeneficiary beneficiaryCategory={beneficiaryCategory} beneficiaries={beneficiaries} beneficiaryIndex={index} benName={benName} updateBeneficiaries={updateBeneficiaries} toggleButtonState={toggleButtonState} setRerenderAllocation={setRerenderAllocation}/>
          <BdmModalDeleteBeneficiary beneficiaryCategory={beneficiaryCategory} beneficiaryIndex={index} benName={benName} handleDeleteBeneficiary={handleDeleteBeneficiary}/>
        </StyledDiv>
      </TableData>
      <TableData style={{ verticalAlign: 'middle' }}>{getBeneficiaryTypeLabel(beneficiaryType)}</TableData>

      {!toggleButtonState && rerenderAllocation ? (<TableData>
            <StyledTextInput initialValue={allocation} field={`allocationPercentage-${beneficiaryCategory}${index}`} hideLabel={true} label={'Allocation Percentage'} type={'text'} onValueChange={onValueChange} maxLength={3} mask={BdmBeneficiaryUtils.validateAllocationInForm} aria-label={benName + " " + displayText.allocation}/>
        </TableData>) : (<TableData style={{ verticalAlign: 'middle', textAlign: 'center' }}>
          <StatusBadge aria-label={benName + " " + displayText.allocation} backgroundColor={'secondary'}>{displayText.equal}</StatusBadge>
        </TableData>)}
    </TableRow>);
};
